import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CheckButtonResponse } from '../../core/model/button-fields';
import { CampoSolicitud } from '../../core/model/campo-solicitud';
import { FechaContenedor } from '../../core/model/inventories';
import { Template } from '../../core/model/template';
import { SelectValue, TemplateField } from '../../core/model/template-field';
import { AlmacenService } from '../../core/services/almacen.service';
import { TemplatesService } from '../../core/services/templates.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { CamposPlantillaComponent } from '../../home/formulario-plantilla/campos-plantilla/campos-plantilla.component';
import { RangoSimple } from '../../core/model/Rangos';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-filtros-tablas',
  templateUrl: './filtros-tablas.component.html',
  styleUrls: ['./filtros-tablas.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        opacity: 1,
        transform: 'scaleY(1)'
      })),
      state('out', style({
        opacity: 0,
        transform: 'scaleY(0)'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ]),
    trigger('hiddenContainer', [
      state('in', style({
        height: '*'
      })),
      state('out', style({
        height: '0'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class FiltrosTablasComponent implements OnInit {
  @ViewChild('camposss') camposPlantillaComponent: CamposPlantillaComponent;

  @Input() tipoSolicitud: string;
  @Input() serieId: number;
  @Input() clienteId: number;
  // @Input() isContainerContent = false;
  @Input() type: string;
  @Input() templateFields: TemplateField[];
  @Input() addIDContenidoFilter = false;

  @Output() filtrosEstablecidos = new EventEmitter<TemplateField[]>();

  camposRangoSimple = new Map<string, RangoSimple>();

  advancedSearchState = 'out';
  loading = false;
  serieValida = false;
  templateId: number;
  public campos: TemplateField[] = undefined;
  camposSencillos: TemplateField[] = undefined;
  formGroup: FormGroup;
  selectValueMap = new Map<number, SelectValue[]>();
  hasResetMultivalues = false;
  showError = false;
  public bsConfig: BsDatepickerConfig;

  camposRangoNombres: string[] = [];
  camposRango = new Map<string, { desde: TemplateField, hasta: TemplateField }>();
  rangeSearchMode: string;

  constructor(
    private templatesService: TemplatesService,
    private toastrService: ToastrService,
    private almacenService: AlmacenService,
    private cdRef: ChangeDetectorRef,
    private authService: AuthenticationService,
    private utilsService: UtilitiesService) { }

  ngOnInit() {
    this.bsConfig = this.utilsService.getDatepickerConfig();
    this.rangeSearchMode = this.authService.getBusquedaRangoSimple();
    this.getCampos();
  }

  private getCampos() {
    if (this.tipoSolicitud === 'materiales') {
      this.campos = [];
      this.loading = false;
      return;
    }
    if (!this.templateFields) {
      this.templatesService.getTemplateFields(this.tipoSolicitud, this.serieId).subscribe((plantilla: Template) => {
        if (plantilla === null) {
          this.toastrService.warning('La serie seleccionada no puede ser usada para este tipo de solicitud.', 'Serie no válida');
          this.serieValida = false;
          this.loading = false;
        } else {
          this.templateId = plantilla.idPlantilla;
          this.serieValida = true;
          this.campos = plantilla.campos;
          let campoIdContenido = new TemplateField();
          campoIdContenido.nombre = 'ID_CONTENIDO';
          campoIdContenido.descripcion = 'ID Contenido';
          campoIdContenido.tipo = 'NUMERIC';
          this.campos.push(campoIdContenido);
          this.mapCamposCondicionales();
          this.mapCamposRango();
          this.formGroup = this.getFormGroup();
          this.loading = false;
        }
      });
    } else {
      this.campos = this.templateFields;
      this.mapCamposCondicionales();
      this.mapCamposRango();
      this.formGroup = this.getFormGroup();
      this.loading = false;
    }
  }
  mapCamposRango() {
    const camposSencillos: TemplateField[] = [];
    this.campos.forEach(campo => {
      if (campo.rango) {
        const aux = this.camposRango.get(campo.descripcion) || { desde: undefined, hasta: undefined };
        if (campo.rango === 1) {
          aux.desde = campo;
        }
        if (campo.rango === 2) {
          aux.hasta = campo;
        }
        this.camposRango.set(campo.descripcion, aux);
        if (this.camposRangoNombres.indexOf(campo.descripcion) < 0) {
          this.camposRangoNombres.push(campo.descripcion);
        }
      } else {
        camposSencillos.push(campo);
      }
    });

    this.camposSencillos = [...camposSencillos];
  }


  private getFormGroup(): any {
    const group = {};
    this.campos.forEach((campo: TemplateField) => {
      const control = new FormControl(campo.value);
      const validators = [];
      if (campo.max) {
        validators.push(Validators.maxLength(campo.max));
      }
      control.setValidators(validators);
      group[campo.nombre] = control;
    });
    return new FormGroup(group);
  }

  private mapCamposCondicionales() {
    let camposReferenciados: number[] = [];
    this.selectValueMap = new Map<number, SelectValue[]>();

    // Establecemos los valores posibles para cada uno de los campos que están siendo referenciados por algún valor de otro campo
    this.campos.filter((campo: TemplateField) => campo.tipo === 'ARRAY').forEach((campo: TemplateField) => {
      if (campo.value) {
        camposReferenciados = this.getCamposReferenciados(campo, camposReferenciados);
      }
    });

    // Se obtienen todos los valores posibles como disponibles para aquellos campos que no han sido referenciados
    this.campos.filter((campo: TemplateField) => campo.tipo === 'ARRAY' && camposReferenciados.indexOf(campo.id) < 0).forEach((campo: TemplateField) => {
      this.selectValueMap.set(campo.id, campo.defaultValues);
    });

    this.campos.forEach((campo: TemplateField) => {
      this.proccessFieldsRange(campo);
    });

  }

  private proccessFieldsRange(campo: TemplateField) {
    if (campo.rango) {
      const aux = this.camposRango.get(campo.descripcion) || {
        desde: undefined,
        hasta: undefined
      };
      if (campo.rango === 1) {
        aux.desde = campo;
      }
      if (campo.rango === 2) {
        aux.hasta = campo;
      }
      this.camposRango.set(campo.descripcion, aux);

      if (this.camposRangoNombres.indexOf(campo.descripcion) < 0) {
        this.camposRangoNombres.push(campo.descripcion);
      }
    }
    if (campo.subtipo === 'RANGO_SIMPLE') {
      const aux = CamposPlantillaComponent.createRangoSimple(campo);
      this.camposRangoSimple.set(campo.descripcion, aux);
    }
  }

  private getCamposReferenciados(campo: TemplateField, camposReferenciados: number[]): number[] {
    let valorCampo: any;
    if (!campo.multivalue) {
      valorCampo = campo.defaultValues.filter((value: SelectValue) => value.id === +campo.value)[0];
      camposReferenciados = this.setValorEnCamposReferenciados(valorCampo, camposReferenciados, campo.multivalue);
      return camposReferenciados;
    }
    valorCampo = [].concat(campo.value).map((v: SelectValue) => v.id);
    const valores = campo.defaultValues.filter((value: SelectValue) => valorCampo.indexOf(value.id) >= 0);
    valores.forEach((valor: SelectValue) => {
      camposReferenciados = this.setValorEnCamposReferenciados(valor, camposReferenciados, campo.multivalue);
    });

    return camposReferenciados;
  }

  private setValorEnCamposReferenciados(valor: SelectValue, camposReferenciados: number[], isMultivalue: boolean): number[] {
    if (valor && valor.campoPrecedesor > 0) {
      const campoPredecesor = this.campos.filter((c: TemplateField) => c.id === valor.campoPrecedesor)[0];

      if (campoPredecesor) {
        camposReferenciados.push(valor.campoPrecedesor);
        // Si el campo predecesor no tiene valores visibles, se le asignan a partir del valor seleccionado
        // Si el campo predecesor tiene valores visibles, se realiza la insersección de estos con los correspondientes al valor seleccionado
        if (!this.selectValueMap.get(valor.campoPrecedesor) || this.selectValueMap.get(valor.campoPrecedesor).length === 0) {
          this.selectValueMap.set(valor.campoPrecedesor, campoPredecesor.defaultValues
            .filter((v: SelectValue) => valor.valoresCampoPredecesor.indexOf(v.id) >= 0));
        } else {
          const nuevosValores = campoPredecesor.defaultValues.filter((v: SelectValue) => valor.valoresCampoPredecesor.indexOf(v.id) >= 0).map(v => v.id);
          this.selectValueMap.set(valor.campoPrecedesor, this.selectValueMap.get(valor.campoPrecedesor)
            .filter((v: SelectValue) => nuevosValores.indexOf(v.id) >= 0));
        }

        // Si el campo tenía un valor que ahora no puede tener, este se descarta
        if (!campoPredecesor.multivalue) {
          // Si el campo predecesor no es multivalue
          if (this.selectValueMap.get(valor.campoPrecedesor).map(v => v.id).indexOf(+campoPredecesor.value) < 0) {
            campoPredecesor.value = undefined;
          }
        } else {
          // Si el campo predecesor es multivalue
          const campoPredecesorIds = this.selectValueMap.get(valor.campoPrecedesor).map(vPosible => vPosible.id);
          const concat = [].concat(campoPredecesor.value);
          if (!isMultivalue) {
            campoPredecesor.value = concat.filter(vAsignado => campoPredecesorIds.indexOf(vAsignado) >= 0);
          } else {
            campoPredecesor.value = concat.filter(vAsignado => campoPredecesorIds.indexOf(vAsignado.id) >= 0);
          }
        }
      }
    }
    return camposReferenciados;
  }

  hasError(campo: string) {
    const c = this.formGroup.controls[campo];
    return c.invalid && (c.touched || c.dirty);
  }

  comprobarCampo(idCampo: number) {
    const campo = this.campos.filter((c: TemplateField) => c.id === idCampo)[0];
    if (this.formGroup.controls[campo.nombre].hasError('maxlength')) {
      campo.errorMessage = 'Longitud máxima: ' + campo.max + ' caracteres';
    } else {
      campo.errorMessage = undefined;
    }
    this.formGroup.controls[campo.nombre].markAsTouched();
  }

  updateSelected(event: any[], campo: TemplateField) {
    const selected = event.map(value => value.id);
    // campo.value = campo.defaultValues.filter((value: SelectValue) => selected.indexOf(value.id) >= 0);
    this.mapCamposCondicionales();
  }

  hasBeenReseted(event: boolean) {
    if (event) {
      this.hasResetMultivalues = false;
    }
  }

  checkAlmacenContenedor(value: number): Observable<CheckButtonResponse> {
    return this.almacenService.validateContainer(value as number, this.clienteId) as Observable<CheckButtonResponse>;
  }

  limpiar() {
    this.formGroup.reset();

    this.campos.forEach((campo: TemplateField) => {
      campo.errorMessage = undefined;
      if (campo.tipo === 'ARRAY') {
        campo.value = null;
      } else if (campo.tipo !== 'DATE') {
        campo.value = null;
      } else {
        campo.value = null;// [new FechaContenedor()];
      }
    });
    this.hasResetMultivalues = true;
    this.showError = false;
    this.serieValida = false;
    this.emitFilters();
  }

  emitFilters() {
    if (this.formGroup.valid) {
      this.showError = false;
      const camposFiltros: TemplateField[] = [];
      this.campos.filter(campo => this.hasValue(campo)).forEach((campo: TemplateField) => {
        camposFiltros.push(campo);
      });
      this.filtrosEstablecidos.emit(camposFiltros);
    } else {
      this.showError = true;
      this.marcarCamposErroneos();
    }
  }
  hasValue(campo: TemplateField): boolean {
    if (campo.tipo === 'ARRAY' && campo.value === '-1') {
      return false;
    }
    if (campo.tipo !== 'DATE') {
      return !(!campo.value || [].concat(campo.value).length === 0);
    }
    return !!campo.value;
  }

  private marcarCamposErroneos() {
    this.campos.forEach(campo => this.comprobarCampo(campo.id));
  }

  toggleAdvancedSearch() {
    this.advancedSearchState = this.advancedSearchState == 'in' ? 'out' : 'in';
    this.cdRef.detectChanges();
  }

  setValorRango(limite: string, campoRango: string, $event: string | Date) {
    this.camposRango.get(campoRango)[limite].value = $event;
  }


  getTipoCampoRango(campo: string) {
    return this.camposRango.get(campo).desde.tipo;
  }

}
